import Countdown from './modules/countdown';

window.WOWNOWH5 = {
  Countdown
}
